"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=isBoolean;function isBoolean(value){return typeof value==='boolean';}